import { Config, Context, Data, Effect, Layer, pipe } from "effect";
import Stripe from "stripe";
export class UnknownStripeApiError extends Data.TaggedError("@open-revenue/stripe/UnknownStripeApiError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
}
export class StripeApiError extends Data.TaggedError("@open-revenue/stripe/StripeApiError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
}
export class StripeApiAuthenticationError extends Data.TaggedError("@open-revenue/stripe/StripeApiAuthenticationError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
}
export class StripeApiConfigurationError extends Data.TaggedError("@open-revenue/stripe/StripeApiConfigurationError") {
    error;
    constructor(error){
        super(), this.error = error;
    }
}
export class StripeApiContext extends Context.Tag("@open-revenue/stripe/StripeApiContext")() {
    static layer = (config)=>pipe(Effect.succeed(config), Layer.effect(this));
    static layerConfig = (config)=>pipe(Config.unwrap(config), Layer.effect(this));
}
//
// TODO: Handle the different types of responses
//
export const make = (instance)=>Effect.sync(()=>(fn)=>Effect.async((cb)=>{
                fn(instance).then((res)=>cb(Effect.succeed(res))).catch((err)=>{
                    cb(err instanceof Stripe.errors.StripeError ? err.statusCode === 401 ? Effect.fail(new StripeApiAuthenticationError(err)) : Effect.fail(new StripeApiError(err)) : Effect.fail(new UnknownStripeApiError(err)));
                });
            }));
export class StripeApiBaseClient extends Context.Tag("@open-revenue/stripe/StripeApiBaseClient")() {
    static make = make;
}
